import NiceModal from "@ebay/nice-modal-react";
import * as React from "react";
import { useToggleWebsiteSystem, WebsiteSystemItem } from "src/hooks/useWebsiteSystem";
import { isCustomRangeEnded } from "./scheduleForm";
import { WebsiteSystemRenewRangeDialog } from "./WebsiteSystemRenewRangeDialog";
import { WebsiteSystemSwitches } from "./WebsiteSystemSwitches";

export type WebsiteSystemUsageCellProps = {
  item: WebsiteSystemItem;
  canEdit: boolean;
};

// The table's "การใช้งาน" cell. The backend refuses to switch on a row whose
// one-off custom window has already ended, so that one case asks for a new
// window first (and saves it before switching on) instead of sending a PATCH
// that can only fail.
export const WebsiteSystemUsageCell: React.FC<WebsiteSystemUsageCellProps> = ({ item, canEdit }) => {
  const toggle = useToggleWebsiteSystem();

  const handleToggle = (enabled: boolean) => {
    if (!canEdit) return;
    if (enabled && isCustomRangeEnded(item)) {
      NiceModal.show(WebsiteSystemRenewRangeDialog, { item });
      return;
    }
    toggle.mutate({ code: item.code, enabled });
  };

  return <WebsiteSystemSwitches item={item} canEdit={canEdit} isSaving={toggle.isLoading} onToggle={handleToggle} />;
};
